module.exports = __webpack_public_path__ + "img/1F1F2-1F1EA.2b3866d8.svg";